window.Reverb = window.Reverb || {};
Reverb.Messages = window.Reverb.Messages || {};

Reverb.Messages.ToggleReadStatus = (function () {
  function markRead(e, data) {
    toggleAppearance(e);
    Reverb.Badges.decrementBadge('unread_messages_badge');
    updateDropdownCountsForMarkRead();
    updateClickBinding(e.target, 'toggle-message-unread');
  }

  function markUnread(e, data) {
    toggleAppearance(e);
    Reverb.Badges.incrementBadge('unread_messages_badge');
    updateDropdownCountsForMarkUnread();
    updateClickBinding(e.target, 'toggle-message-read');
  }

  function toggleAppearance(e) {
    const clickedLink = $(e.target);
    const conversation = clickedLink.closest('.conversation');
    const statusIcon = clickedLink.find('span');

    statusIcon.toggleClass('ph ph-circle');
    statusIcon.toggleClass('ph-fill ph-circle');
    conversation.toggleClass('conversation--unread');
  }

  function updateDropdownCountsForMarkRead() {
    updateUnreadCount(unreadCount() - 1);
  }

  function updateDropdownCountsForMarkUnread() {
    updateUnreadCount(unreadCount() + 1);
  }

  function updateUnreadCount(newUnreadCount) {
    unreadButton().html(I18n.t('js.dashboard.messages.unreadFilterLabel', { count: newUnreadCount }));
  }

  // After we mark something read/unread, we will update
  // the data binding so that next time, it binds to the
  // opposite action
  function updateClickBinding(target, newBinding) {
    $(target).attr('data-bind', newBinding);
  }

  function getCurrentCount(unreadButton) {
    if (unreadButton.length) {
      return parseInt(unreadButton.html().match(/\d+/)[0]);
    }
    return 0;
  }

  function unreadButton() { return $('[data-bind=\'message-filter-unread\']'); }
  function unreadCount() { return getCurrentCount(unreadButton()); }

  function bindToggleReadStatus() {
    $(document).on('ajax:success', '[data-bind=\'toggle-message-unread\']', markUnread);
    $(document).on('ajax:success', '[data-bind=\'toggle-message-read\']', markRead);
  }

  bindToggleReadStatus();
}());
